<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 
-->
<template>
  <jh-base-dialog
    title="系统列表"
    :visible="visible"
    append-to-body
    top="15vh"
    width="800px"
    @close="close"
  >
    <template slot="body">
      <el-row :gutter="20">
        <el-col :span="8" v-for="item in systemList" :key="item.softAppId">
          <el-card shadow="hover" @click.native="goSystem(item)"  :class="{active: appId === item.softAppId}">
            <div class="tc">{{item.softName}}</div>
          </el-card>
        </el-col>
      </el-row>
    </template>
  </jh-base-dialog>
</template>

<script>
export default {
  name: "changeSystem",
  components: {},

  data() {
    return {
      visible: false,
      systemList:[]
    };
  },

  computed: {
    appId: function () {
      return this.$store.state.app.appId
    }
  },

  created() {
    this.getData();
  },

  methods: {
    goSystem(item) {
      this.$store.commit("visitedPathReset");
      this.$store.commit("changeApp",item.softAppId);
      this.$router.push("/home")
      window.location.reload();
    },
    getData() {
      this.$api.formPost("/api/major/syssoft/ware/doGetListByUser",{}).then(res => {
        this.systemList = res.retBody;
      })
    },
    close() {
      this.visible = false;
    },
    open() {
      console.log("open");
      if(this.systemList.length === 0) {
        this.$message.warning("暂无子系统")
        return;
      }
      this.visible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-card {
  margin-bottom: 20px;
  cursor: pointer;
}
/deep/ .el-card__body:hover {
  color: var(--theme-color);
}
.active {
  border: 1px solid var(--theme-color);
  color: var(--theme-color);
}
</style>



// WEBPACK FOOTER //
// src/jh/pages/home/components/changeSystem/index.vue